import { render, staticRenderFns } from "./ResultadoPendencias.vue?vue&type=template&id=192fa8ab&scoped=true"
import script from "./ResultadoPendencias.vue?vue&type=script&lang=js"
export * from "./ResultadoPendencias.vue?vue&type=script&lang=js"
import style0 from "./ResultadoPendencias.vue?vue&type=style&index=0&id=192fa8ab&prod&lang=scss&scoped=true"
import style1 from "./ResultadoPendencias.vue?vue&type=style&index=1&id=192fa8ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192fa8ab",
  null
  
)

export default component.exports